import React, { useState } from 'react';
import { RATING_OPTIONS, submitFeedback } from '../utils/feedback';
import { trackDoseWiseEvents } from '../utils/analytics';

// DOS-38: one-tap micro-prompt shown occasionally after a dose is logged.
// Throttled by the caller (LogDosePage) via microPromptDue()/markMicroPromptShown()
// so it appears at most once every 14 days; dismissing counts as shown.
interface Props {
  open: boolean;
  onClose: () => void;
}

const PostDoseFeedbackPrompt: React.FC<Props> = ({ open, onClose }) => {
  const [done, setDone] = useState(false);

  if (!open) return null;

  const handleRate = async (rating: number) => {
    setDone(true);
    trackDoseWiseEvents.feedbackSubmitted(rating, false);
    try {
      await submitFeedback({ rating, trigger: 'post_dose' });
    } catch {
      // Best effort — never interrupt the user over a failed micro-rating.
    }
    setTimeout(onClose, 1500);
  };

  return (
    <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-2000 w-[92vw] max-w-sm">
      <div className="bg-gray-800 text-gray-50 rounded-xl px-5 py-4 shadow-2xl border border-gray-700 text-center">
        {done ? (
          <p className="m-0 font-medium">Thanks — noted! 🙏</p>
        ) : (
          <>
            <div className="flex items-center justify-between mb-2">
              <p className="m-0 font-medium">How was logging that dose?</p>
              <button
                aria-label="Dismiss"
                className="text-gray-400 hover:text-white ml-3"
                onClick={onClose}
              >
                ✕
              </button>
            </div>
            <div className="flex justify-between gap-1">
              {RATING_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  aria-label={option.label}
                  title={option.label}
                  className="flex-1 py-1.5 rounded-lg text-2xl bg-gray-700 border border-gray-600 hover:bg-gray-600 transition-colors duration-150"
                  onClick={() => handleRate(option.value)}
                >
                  {option.emoji}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PostDoseFeedbackPrompt;
